import React, { forwardRef, useImperativeHandle, useMemo, useState } from 'react';
import {EuiFlexGroup,EuiFlexItem, EuiFormRow, EuiButton, EuiSpacer, EuiTextColor, EuiTextArea} from '@elastic/eui';
import {ComboSociedadesContainer as ComboSociedades} from '../../../components/Combos/Sociedades/container';
import SelectorFecha from '../../../../../shared/components/Combos/Fecha';
import {ListaAdjuntosContainer as ListadoAdjuntos} from '../../../components/Listas/Adjuntos/container';
import{ CreateFechaMoment, ToSQL } from '../../../../../shared/utils/fecha';


export const FormularioEditarPartesFinSemana = forwardRef((props,ref)=>{
  
  let {onSave,onDownLoad,onRemoveAdjuntos,handleChangeTypeAdjunto,selected, refreshAdjuntos, onClose, user} = props

  let [fecha, setFecha] = useState(CreateFechaMoment(selected.fecha));
  
  let [sociedad,setSociedad] = useState(selected.idSociedad)
  let [observaciones, setObservaciones] = useState(selected.observaciones)
  const [nAdjuntos, setNAdjuntos] = useState(0)
  
  const onSaveData = () =>{
    let data = {
      idSociedad: sociedad[0].value, 
      fecha: ToSQL(fecha,"-"), 
      observaciones: observaciones===''?null:observaciones
    }
    
    if(comprobarErrores()){
        onSave && onSave({...selected,...data})
    }
  }

  const comprobarErrores = () => {return !isInvalidSociedad;}

  const handleRemoveAdjuntos = (idAdjunto,todos)=>{
    let data ={idParte: selected.idParte, idAdjunto: idAdjunto, todosPartes: todos}
    const errorDesplazado = nAdjuntos === 1
    return onRemoveAdjuntos && onRemoveAdjuntos(data, errorDesplazado);
  }

  useImperativeHandle(
    ref,
    () => ({
        onSaveDataForm(){
          onSaveData()
        }
     })
  )

  const isWeekEnd = (date) => {
    const day = date.day();
    return day === 0 || day === 6;
};

  const isInvalidSociedad = useMemo(() => sociedad===undefined || sociedad.length===0,[sociedad])
  const isInvalidDay = (date)=>(date!==undefined ? !isWeekEnd(date) : false)

  const onChangeTypeAdjunto = (adjunto)=>{
    const dataType = {IdAdjunto:adjunto.id, IdTipoAdjunto:adjunto.tipo.idTipoAdjunto};
    handleChangeTypeAdjunto&&handleChangeTypeAdjunto(dataType)
  }

  const getNumberAdjuntos = (nAdjuntos) => {setNAdjuntos(nAdjuntos)}

  return (
    <>
    <EuiFlexGroup>
      <EuiFlexItem>
          <EuiFormRow label={`Fecha`} fullWidth isInvalid={isInvalidDay(fecha)}>
            <SelectorFecha fullWidth selected={fecha} onChange={date => setFecha(date)} filterDate={isWeekEnd} isInvalid={isInvalidDay(fecha)}/>
          </EuiFormRow>
        </EuiFlexItem>
        <EuiFlexItem>
          <EuiFormRow label="Sociedad" isInvalid={isInvalidSociedad}  fullWidth>
            <ComboSociedades fullWidth selectedOptions={sociedad} onChange={value =>{setSociedad(value)}} 
            isInvalid={isInvalidSociedad} user={selected.dni} fechaHasta={fecha}/>
          </EuiFormRow>
        </EuiFlexItem>
    </EuiFlexGroup>

    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="Observaciones">
          <EuiTextArea
            fullWidth
            draggable={false}
            compressed
            resize="none"
            rows={3}
            value={observaciones}
            onChange={(e) => setObservaciones(e.target.value)}
          />
        </EuiFormRow>
        </EuiFlexItem>
        <EuiFlexItem>
          <EuiFormRow fullWidth label="Adjuntos (click en adjunto para descargar)">
            <ListadoAdjuntos
              style={{height:"150px", width:"100%!important", maxWidth:"100%", overflowY:"auto"}}
              fullWidth
              idParte={selected && selected.idParte}
              handleDownload={onDownLoad}
              handleRemove={handleRemoveAdjuntos}
              getNumberAdjuntos={getNumberAdjuntos}
              refresh={refreshAdjuntos}
              onChangeTypeAdjunto={onChangeTypeAdjunto}
            />
          </EuiFormRow>
          </EuiFlexItem>
    </EuiFlexGroup>

    </>
      
  )
})